import { EngagementSubmissionData } from '@/generated/graphql';

export const PROPERTY_CHANGED = 'PROPERTY_CHANGED';

export type ActionType<T extends EngagementSubmissionData> = {
  type: typeof PROPERTY_CHANGED;
  payload: {
    key: keyof T;
    value: T[keyof T];
  };
};

export const propertyChanged = <T extends EngagementSubmissionData>(
  key: keyof T,
  value: T[keyof T],
): ActionType<T> => ({
  type: PROPERTY_CHANGED,
  payload: { key, value },
});
